import './SimpleHeader.css'

import React from 'react'

export default function SimpleHeader({ title }) {
  return (
    <header id="main-header" className="blog-main-header gradient-color">
      <div className="overlay gradient-color" />

      <div className="title">
        <h2 className="">{title}</h2>
      </div>
    </header>
  )
}



// WEBPACK FOOTER //
// ./src/components/SimpleHeader.js